// extracted by mini-css-extract-plugin
export default {"articleBlank":"article_blank_articleBlank__TYoUn","blocksContainer":"article_blank_blocksContainer__kb4vn","blockWrapper":"article_blank_blockWrapper__GTyqQ"};